var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-cog fa-spin fa-2x fa-fw",staticStyle:{"color":"#17a2b8"}})])
}]

export { render, staticRenderFns }